module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content front"
  }, [_c('FrontSolgan'), _c('FrontBeehive'), _c('FrontQAPublic'), _c('FrontLesson'), _c('FrontVideo')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f9493b9","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Front/Body/index.vue
// module id = 1623
// module chunks = 0